import type { ThemeConfig } from "antd";
import { theme as antdTheme } from "antd";

export const palette = {
  light: {
    brand: "#5B6CFF",
    accent: "#FF9F43",
    success: "#22C55E",
    warning: "#F59E0B",
    danger: "#EF4444",
    bgCanvas: "#FAFAFB",
    bgSurface: "#FFFFFF",
    borderSoft: "#EAEAEE",
    textPrimary: "#0F1115",
    textSecondary: "#5B6072",
  },
  dark: {
    brand: "#7C8AFF",
    accent: "#FFB266",
    success: "#4ADE80",
    warning: "#FBBF24",
    danger: "#F87171",
    bgCanvas: "#0E0F13",
    bgSurface: "#1A1B22",
    borderSoft: "#2A2C36",
    textPrimary: "#F5F6FA",
    textSecondary: "#9CA0B0",
  },
} as const;

export type ColorMode = "light" | "dark";

export type FontScale = "sm" | "md" | "lg" | "xl";

/** body 上 zoom 的倍率,影响整个 UI(包括 inline 写死的 px) */
export const FONT_SCALE_ZOOM: Record<FontScale, number> = {
  sm: 0.875,
  md: 1,
  lg: 1.15,
  xl: 1.3,
};

/** AntD token 内部基准字号(配合上面的 zoom 一起作用) */
const BASE_FONT_SIZE = 18;

export function makeAntdTheme(mode: ColorMode): ThemeConfig {
  const p = palette[mode];
  return {
    algorithm: mode === "dark" ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
    cssVar: true,
    token: {
      colorPrimary: p.brand,
      colorSuccess: p.success,
      colorWarning: p.warning,
      colorError: p.danger,
      colorBgLayout: p.bgCanvas,
      colorBgContainer: p.bgSurface,
      colorBorder: p.borderSoft,
      colorText: p.textPrimary,
      colorTextSecondary: p.textSecondary,
      borderRadius: 8,
      borderRadiusLG: 12,
      fontFamily:
        'Inter, -apple-system, BlinkMacSystemFont, "PingFang SC", "Noto Sans SC", "Microsoft YaHei", sans-serif',
      fontSize: BASE_FONT_SIZE,
      controlHeight: 40,
    },
    components: {
      Button: { controlHeight: 40, fontWeight: 500 },
      Input: { controlHeight: 40 },
      Layout: { headerBg: p.bgSurface, bodyBg: p.bgCanvas, siderBg: p.bgSurface },
      Menu: { itemSelectedBg: `${p.brand}1A`, itemSelectedColor: p.brand, itemBorderRadius: 8 },
      Card: { borderRadiusLG: 12 },
      Drawer: { paddingLG: 16 },
      Modal: { borderRadiusLG: 16 },
    },
  };
}
